/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const changeOrConfigurationErrorEnumsFaultTypeOptionEnum = {
    Overload: 'Overload',
    ShortCircuit: 'ShortCircuit',
    BreakerTrip: 'BreakerTrip',
    Other: 'Other',
} as const;

export type ChangeOrConfigurationErrorEnumsFaultTypeOptionEnumKey =
    (typeof changeOrConfigurationErrorEnumsFaultTypeOptionEnum)[keyof typeof changeOrConfigurationErrorEnumsFaultTypeOptionEnum];

export type ChangeOrConfigurationErrorEnumsFaultTypeOption = ChangeOrConfigurationErrorEnumsFaultTypeOptionEnumKey;
